import { ApiAction } from '../../../index';

export const GET_ENTERPRISE_PORTFOLIOS: ApiAction = {
  type: 'connect/enterprise/portfolios',
  endpoint: 'enterprises/:id/portfolios',
  transform: (res: any) => res.data,
};

export const DELETE_ENTERPRISE_GROUP_PORTFOLIO: ApiAction = {
  type: 'connect/enterprises/delete-group-portfolio',
  endpoint: 'enterprises/:id/groups/:groupId/portfolios/:portfolioId/',
};

export const DELETE_ENTERPRISE_GROUP_PORTFOLIOS: ApiAction = {
  type: 'connect/enterprises/delete-group-portfolio-many',
  endpoint: 'enterprises/:id/groups/:groupId/portfolios',
};
